import "./plantationHome.css";
import React, { useState, useEffect } from "react";
import { authKey, GET_USER_DETAILS, RescScmAdminMember } from "../../../common/URLs";
import { useLocation } from "react-router-dom";

import jwt from "jwt-decode";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { Helmet } from 'react-helmet-async';
import { Card, Container, Grid, Button, Stack, CardContent, Typography} from '@mui/material';
import { useTranslation } from "react-i18next";
import { ProceedIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function PlantationHome() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [emailId, setEmailId] = useState();
  const [userId, setUserId] = useState();
  const [roles, setRoles] = useState();
  const [userDetails, setUserDetails] = useState();

  const [urn, setUrn] = useState();
  const [urnToCreatePlant, setUrnToCreatePlant] = useState();

  useEffect(() => {
    setUrnToCreatePlant(location?.state?.data?.urn);
  }, []);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
      if (decoded.extension_URN) {
        setUrn(decoded.extension_URN);
      }
    }
  }, [getLocalStorageItem('id_token')]);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));

      const email = decoded.emails?.[0];
      setEmailId(email);

    }
  }, [getLocalStorageItem('id_token')]);
  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": emailId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setUserDetails(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

 const onCreateProceed = (e) => {
  e.preventDefault();
    if(RescScmAdminMember.includes(checkUserDetails)) {
    navigate("scmMemberCreatePlant");
  } 
  else {
    navigate("growerBatchCreate");
  }
  
 }

 let checkUserDetails = localStorage.getItem('role');

  return (
    <>
    <Helmet>
      <title> Home | ABEPL </title>
    </Helmet>
    <Container maxWidth="xl">
      <Grid container>
        <Grid item xs={12} lg={12}>        
          <Stack spacing={1}>
          {!PROD && <p className='pageNumberingResc'>RES19</p>}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6}>
                <Card style={{ borderRadius: 10 }}>
                  <CardContent>
                    <Stack spacing={1}>
                      <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}}>
                      {t('resource.createPlantationBatch')}
                      </Typography>
                      <Button endIcon={<ProceedIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                        size="medium"
                        variant="contained"
                        onClick={(e) => onCreateProceed(e)}>{t('resource.proceed')}</Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Card style={{ borderRadius: 10 }}>
                  <CardContent>
                    <Stack spacing={1}>
                      <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}} >
                      {t('resource.viewPlantationBatch')}
                      </Typography>
                      <Button endIcon={<ProceedIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                        size="medium"
                        variant="contained"
                        onClick={() => navigate("allPlantBatch")}
                        >{t('resource.proceed')}</Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  </>
  );
}
export default PlantationHome;
